import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '../Texte';
import { PastilleEntreprise } from '../OffreCarte';
import { colors, radius, spacing, typography } from '../../theme/tokens';
import type { Offre } from '../../types/offres';

/** L'offre préparée : logo de l'entreprise, sinon ses initiales, puis entreprise et poste. */
export function BandeauOffre({ offre }: { offre: Offre }) {
  return (
    <View style={styles.bandeau} accessible accessibilityLabel={[offre.entreprise.nom, offre.titre].filter(Boolean).join(', ')} testID="bandeau-offre">
      <PastilleEntreprise offre={offre} taille={40} />
      <View style={styles.textes}>
        {offre.entreprise.nom ? (
          <Text style={styles.entreprise} numberOfLines={1}>
            {offre.entreprise.nom}
          </Text>
        ) : null}
        <Text style={styles.poste} numberOfLines={1}>
          {offre.titre}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bandeau: { flexDirection: 'row', alignItems: 'center', gap: spacing.md, padding: spacing.md, borderRadius: radius.lg, backgroundColor: colors.inkSoft },
  textes: { flex: 1, gap: 2 },
  entreprise: { fontSize: typography.small.size, lineHeight: typography.small.lineHeight, fontWeight: '700', color: colors.grey200 },
  poste: { fontSize: typography.bodyMd.size, lineHeight: typography.bodyMd.lineHeight, fontWeight: '600', color: colors.white },
});
